"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var storeProvider_1 = require("./storeProvider");
var routes_1 = __importDefault(require("./routes"));
require("./app.scss");
function App() {
    return ((0, jsx_runtime_1.jsx)("div", { className: "App", children: (0, jsx_runtime_1.jsx)(storeProvider_1.StoreProvider, { children: (0, jsx_runtime_1.jsx)(routes_1.default, {}) }) }));
}
exports.default = App;
